// @ts-nocheck
import { CASE_CREATE_ERROR, CASE_CREATE_LOADING, CASE_CREATE_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const CaseCreateReducer = (state = initialState, action) => {
    switch (action.type) {
        case CASE_CREATE_LOADING:
            return Object.assign({}, state, { loading: true })
        case CASE_CREATE_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case CASE_CREATE_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

